import { createFeature, createReducer, on } from '@ngrx/store'
import {
  loginSuccess,
  loginFailure,
  logout,
  register,
  registerSuccess,
  registerFailure,
  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  resetPassword,
  resetPasswordSuccess,
  resetPasswordFailure,
  login,
  refreshTokenSuccess,
  refreshTokenFailure,
  loadCurrentUser,
  loadCurrentUserSuccess,
  loadCurrentUserFailure,
  resetThankYouMessage,
  loadSubscription,
  loadSubscriptionSuccess,
  loadSubscriptionFailure,
  logoutSuccess,
  logoutFailure,
  updateUser,
  updateAuthUser,
  loadPermissionsSuccess,
  loadPermissionsFailure,
  restoreSession
} from './auth.actions'
import { Office } from '../office/office.state'
import { Designation } from '../designation/designation.state'
import { AssignedTo, Role, RoleState } from '../role-permission/role-permission.state'
import { City } from '../city/city.state'
import { incomingSubscription } from '../../services/subscriptions'
import { Business } from '../business/business.state'
import { PermissionSet, PermissionSetAssignedTo } from '../permission-sets/permission-sets.state'
import { updateBusinessSuccess } from '../business/business.actions'
import { updateEmployeeSuccess } from '../user/user.actions'

export interface UserBusinesses {
  id: string
  businessName: string
  picture: string
}
export interface User {
  id: string
  email: string
  firstName: string
  lastName: string
  name?: string
  picture: string | null
  pictureUrl: string
  // role: string
  userRole: UserRole
  role: UserRole
  // business: {
  //   id: string
  //   address: string
  //   businessName: string
  //   picture: string
  //   pictureUrl: string
  //   user: {
  //     id: string
  //     email: string
  //     firstName: string
  //     lastName: string
  //     name?: string
  //     picture: string | null
  //     pictureUrl: string
  //     role: string
  //   }
  //   parentBusinessId: string
  // }
  business: Business
  // businesses: { id: string; businessName: string; picture: string }[]
  disabled: boolean
  portalAccess: boolean
  mobile?: string
  office?: Office
  designation?: Designation
  designationName?: string
  empId: string
  joiningDate: Date | string
  about: string
  birthdate: string
  gender: string
  emergencyContact: {
    nameP: string
    relationshipP: string
    phoneP: string
    phone2P: string
    nameS: string
    relationshipS: string
    phoneS: string
    phone2S: string
  }
  businessId: string
  officeId: string
  designationId: string
  desingnation: Designation
  departmentId: string
  departmentName: string
  address: string
  cityId: string
  city: City
  country_id: string
  state_id: string
  zipCode: string
  referenceIdFacebook: string
  referenceIdInstagram: string
  referenceIdLinkedIn: string
  referenceIdTwitter: string
  referenceIdWhatsapp: string
  referenceIdSkype: string
  personalEmail: string
  personalMobile: string
  // userRole: { id: number; permissions: Record<string, string[]> }
  // business: { id: string; businessName: string; picture: string; pictureUrl: string }
  businesses: UserBusinesses[]
  businessIds: string[]
  // permissionSets?: Role[]
  userPermissionSets?: PermissionSetAssignedTo[]
  permissionSets?: AssignedTo[]
  createdAt: Date
  updatedAt: Date
  createdById: string
  createdByUser: User
  lastModifiedById: string
  lastModifiedByUser: User
  lastModifiedOn: Date
  userRoles: UserRole[]
  offboard?: boolean
  offboardStatus?: string
  employmentType?: string
  employeeResignations?: EmployeeResignation[]
  showInitials?: boolean
}

export interface AuthState {
  accessToken: string | null
  user: User | null
  subscription: incomingSubscription | null
  isAuthenticated: boolean
  error: string | null
  loading: boolean
  showThankYouMessage: boolean
  refreshToken: string | null
  // ✅ ADD THIS 7may 2026
  permissions: Record<string, string[]>
  authLoaded: boolean
}

const initialState: AuthState = {
  accessToken: null,
  user: null,
  subscription: null,
  isAuthenticated: false,
  error: null,
  loading: false,
  showThankYouMessage: false,
  refreshToken: null,
  //7 may 2026
  permissions: {},
  authLoaded: false
}

// export interface AppState {
//   auth: AuthState
// }

export interface ForgotPasswordState {
  loading: boolean
  error: string | null
  message: string | null
}

export const initialForgotPasswordState: ForgotPasswordState = {
  loading: false,
  error: null,
  message: null
}

export interface EmployeeResignation {
  date: Date | null
  salaryHoldFrom: Date | null
  salaryHoldTo: Date | null
  status: string
  offboardingType: string
  effectiveLastDay: Date | null
  isSalaryHold: boolean
  fullNFinalDate: Date | null
  isFullNFinal: boolean
}

export const authFeature = createFeature({
  name: 'auth',
  reducer: createReducer(
    initialState,
    on(login, state => ({
      ...state,
      loading: true,
      error: null
    })),
    on(loginSuccess, (state, { user, accessToken, refreshToken, subscription }) => ({
      ...state,
      accessToken,
      user,
      subscription,
      isAuthenticated: true,
      authLoaded: true,
      error: null,
      loading: true,
      refreshToken: refreshToken
    })),
    on(loginFailure, (state, { error }) => ({
      ...state,
      error,
      isAuthenticated: false,
      loading: false,
      authLoaded: true
    })),
    // on(logout, () => ({
    //   accessToken: null,
    //   user: null,
    //   subscription: null,
    //   isAuthenticated: false,
    //   error: null,
    //   loading: false,
    //   showThankYouMessage: false,
    //   refreshToken: null
    // })),
    on(logout, state => ({
      ...state,
      loading: true,
      error: null
    })),
    on(register, state => ({
      ...state,
      loading: true,
      error: null
    })),
    on(registerSuccess, (state, { success }) => ({
      ...state,
      success,
      loading: false,
      error: null,
      showThankYouMessage: true
    })),
    on(registerFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
      showThankYouMessage: false
    })),
    // Reset Password Actions
    on(forgotPassword, state => ({
      ...state,
      loading: true,
      forgotPasswordError: null, // Clear any previous errors
      message: null
    })),
    on(forgotPasswordSuccess, (state, { message }) => ({
      ...state,
      loading: false,
      message,
      forgotPasswordError: null // Clear any previous error
    })),
    on(forgotPasswordFailure, (state, { error }) => ({
      ...state,
      loading: false,
      forgotPasswordError: error, // Set error on failure
      message: null
    })),
    on(resetPassword, state => ({
      ...state,
      loading: true,
      error: null,
      message: null
    })),
    on(resetPasswordSuccess, (state, { message }) => ({
      ...state,
      loading: false,
      message
    })),
    on(resetPasswordFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error
    })),
    on(refreshTokenSuccess, (state, { accessToken, user }) => ({
      ...state,
      accessToken,
      user,
      isAuthenticated: true,
      authLoaded: true
    })),
    on(refreshTokenFailure, state => ({
      ...state,
      accessToken: null,
      user: null,
      isAuthenticated: false,
      authLoaded: true
    })),
    on(loadCurrentUser, state => ({
      ...state,
      loading: true
    })),
    on(loadCurrentUserSuccess, (state, { user }) => ({
      ...state,
      user,
      loading: false
    })),
    on(loadCurrentUserFailure, (state, { error }) => ({
      ...state,
      error,
      loading: false
    })),
    on(resetThankYouMessage, state => ({
      ...state,
      showThankYouMessage: false
    })),
    on(loadSubscription, state => ({
      ...state,
      loading: true,
      error: null
    })),
    on(loadSubscriptionSuccess, (state, { subscription }) => ({
      ...state,
      subscription,
      loading: false
    })),
    on(loadSubscriptionFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error
    })),
    on(logoutSuccess, state => ({
      ...initialState,
      accessToken: null,
      user: null,
      subscription: null,
      isAuthenticated: false,
      error: null,
      loading: false,
      showThankYouMessage: false,
      refreshToken: null
    })),
    on(logoutFailure, state => ({
      ...state,
      accessToken: null,
      user: null,
      isAuthenticated: false,
      error: null,
      loading: false
    })),

    // THIS CODE IS ADDED BY SHIVAM
    on(updateUser, (state, { user }) => ({
      ...state,
      user
    })),

    on(updateAuthUser, (state, { user }) => ({
      ...state,
      user
    })),
    // on(updateBusinessSuccess, (state, { business }) => {
    //   if (!state.user) return state

    //   // ✅ Check if updated business is current user's business
    //   if (state.user.business?.id === business.id) {
    //     return {
    //       ...state,
    //       user: {
    //         ...state.user,
    //         business: {
    //           ...state.user.business,
    //           ...business // merge updated fields
    //         }
    //       }
    //     }
    //   }

    //   return state
    // }),
    // on(updateEmployeeSuccess, (state, { user }) => {
    //   if (!state.user) return state

    //   // Check if the updated user is the logged-in user
    //   if (state.user.id === user.id) {
    //     return {
    //       ...state,
    //       user: {
    //         ...state.user,
    //         ...user // merge updated fields
    //       }
    //     }
    //   }

    //   // if it's another employee, do nothing to auth state
    //   return state
    // }),
    on(updateAuthUser, (state, { user }) => ({
      ...state,
      user: state.user ? { ...state.user, ...user } : user
    })),
    on(loadPermissionsSuccess, (state, { permissions }) => ({
      ...state,
      permissions,
      loading: false
    })),

    on(loadPermissionsFailure, state => ({
      ...state,
      loading: false
    })),
    on(restoreSession, (state, { user, accessToken, refreshToken, subscription, permissions }) => ({
      ...state,
      accessToken,
      user,
      subscription,
      isAuthenticated: true,
      authLoaded: true,
      error: null,
      loading: false,
      refreshToken,
      permissions
    }))
  )
})

export const {
  name,
  reducer,
  selectIsAuthenticated,
  selectUser,
  selectSubscription,
  selectError,
  selectLoading,
  selectShowThankYouMessage,
  selectAuthLoaded
} = authFeature

// Selector to get the access token
export const selectAccessToken = (state: AuthState) => state.accessToken

export interface UserRole {
  id: string
  name: string
  status: string
  type: string
  isStandard: boolean
  disabled: boolean
  permissions: Record<string, string[]>
  // permissions: any[]
  createdAt: string
  role: Role
  businessId: string
  business: Business
  officeId: string
  Office: Office
}
